import React, { useEffect, useState } from "react";
import Aceite from "../../TraineeArea/aceite";
import VinculoEncerrado from "../../TraineeArea/vinculo-encerrado";
import style from "./style.module.css";
import Header from "../../../components/Header";
import useWrapper from "../../../hooks/useWrapper";
import { Outlet } from "react-router-dom";
import { Main, Content } from "../../../components/Layout";
import Ad from "../../../components/Ad";

export default function TraineeAreaLayout() {
  const { me, loadMe } = useWrapper();
  const [reload, setreload] = useState(false);
  useEffect(() => {
    !me && loadMe();
    // `loadMe` comes from context and is recreated on every render, and is itself guarded by
    // `!me`, so adding it (and `me`) here would risk re-triggering the fetch in a loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <>
      {me && (
        <>
          <Header fullNav={true} />
          <div className={style.userArea}>
            <Main>
              <Content noBG="true">
                {!me.aceite_virtual ? (
                  <Aceite reload={reload} setreload={setreload} />
                ) : me.access_status === "encerrado" ? (
                  <VinculoEncerrado />
                ) : (
                  <>
                    {me.access_status === "limitado" && (
                      <p className="mb-3">
                        <b>Atenção:</b> seu acesso está limitado a Financeiro e Atendimento até a regularização da sua
                        situação.
                      </p>
                    )}
                    <Outlet />
                  </>
                )}
              </Content>
            </Main>
          </div>
          <Ad />
        </>
      )}
    </>
  );
}
